import * as React from 'react';
import { ResponsivePie, PieDatum } from '@nivo/pie'
import { TagModel } from '../../../models/tagModel';
import * as HelperFunctions from '../../../common/helperFunctions'
import { TagType } from '../../../common/enums';

const getPieData = (tags: Array<TagModel>) => {
    let data = new Array<PieDatum>(0);
    for (let tag of tags) {
        data.push({
            id: HelperFunctions.getEnumLabel(tag.tagType, TagType, true),
            value: tag.value,
            label: HelperFunctions.getEnumLabel(tag.tagType, TagType, true),
            color: HelperFunctions.getLegendColorByText(HelperFunctions.getEnumLabel(tag.tagType, TagType, true))
        })
    }
    return data;
}

const PieChartComponent = (props) => {
    let data: Array<TagModel> = props.data;
    let pieData = getPieData(data);

    return (<div style={{ height: props.isBig ? 600 : 125, width: props.isBig ? 600 : 125 }}>
        <ResponsivePie
            innerRadius={0.4}
            margin={{
                "top": 5,
                "right": props.isBig ? 80 : 10,
                "bottom": 0,
                "left": props.isBig ? 80 : 10
            }}
            tooltip={({ id, value, color }) => (
                <strong style={{ color }}>
                    {id}: {value}%
                </strong>
            )}
            data={pieData}
            slicesLabelsSkipAngle={20}
            colors={(d) => HelperFunctions.getLegendColorByText(d.id + "")}
            enableRadialLabels={false}
            slicesLabelsTextColor={"white"}
            sliceLabel={d => `${d.value}%`}
            legends={props.isBig ? [{
                anchor: "top-left",
                direction: "column",
                itemWidth: 150,
                itemHeight: 40,
                symbolSize: 14,
                symbolShape: 'circle',
                translateX: -80,
                translateY: 5
            }] : []}
        />
    </div>)
}

export default PieChartComponent;